// service errors
export const SERVICE_MAX_STORAGE_REACHED = 'MAX_STORAGE_REACHED'

// errors
export const MAX_STORAGE_REACHED = 'Max storage reached'
export const AUTHENTICATION_ERROR = 'Authentication error'
export const UNKNOWN_ERROR = 'Unknown error'
